import { Skeleton } from '../../../common/skeleton/Skeleton';
import styles from './Apoint.module.scss';

export const APointLoader = () => (
  <div className={styles['paymentMethod-loader-container']} data-testid={'APoint-loader-container'}>
    <div className={styles['paymentMethod-loader-container-apoint']}>
      <div className={styles['header']}>
        <div className={styles['label-container']}>
          <div className={styles['label']}>
            <Skeleton height="100" borderRadius="8" />
          </div>
        </div>
        <div className={styles[`toggle-container`]}>
          <Skeleton height="24" borderRadius="14" width="48" />
        </div>
      </div>
    </div>
  </div>
);
